const UUID_LENGTH = 16;

/** Creates an RFC 4122 version 4 UUID without requiring a secure page context. */
export function createUuid(): string {
  const cryptoApi = globalThis.crypto;
  if (typeof cryptoApi.getRandomValues !== 'function') {
    throw new Error('Secure random UUID generation is unavailable');
  }

  const bytes = cryptoApi.getRandomValues(new Uint8Array(UUID_LENGTH));
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
}
